/**
 * Module Metric mapper
 * @param {Object} data - content data
 * @return {Object} - normalized data
 */

export const mapperModuleMetric = (data: any) => {
  if (!data) {
    return null
  }

  const getSafeMetric = (metric: string) => {
    if (!metric) {
      return { value: '', isPercentageValue: false }
    }

    const trimmedString = metric.trim()
    const withPercentage = trimmedString.endsWith('%')

    if (withPercentage) {
      const numericValue = parseFloat(trimmedString.substring(0, trimmedString.length - 1))
      return {
        value: numericValue.toString(),
        isPercentageValue: true
      }
    }

    return {
      value: metric,
      isPercentageValue: false
    }
  }

  const metricData = getSafeMetric(data.metric)
  return {
    id: data.sys?.id || '',
    contentType: data.contentType || '',
    originalMetric: data.metric || '',
    metric: metricData.value || '',
    complexMetric: data.complexMetric || null,
    isPercentageValue: metricData.isPercentageValue || false,
    description: data.description || '',
    title: data.title || ''
  }
}
